"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.UploaderConsumer = exports.UploaderProvider = void 0;

var _react = _interopRequireDefault(require("react")),
    defaultValue = {
  assetsMap: new Map(),
  addAssetsToMap: void 0,
  addFileToQueue: void 0,
  fetchAssets: void 0,
  removeAsset: void 0,
  updateAsset: void 0
},
    UploaderContext = _react["default"].createContext(defaultValue),
    UploaderProvider = UploaderContext.Provider;

exports.UploaderProvider = UploaderProvider;
var UploaderConsumer = UploaderContext.Consumer;
exports.UploaderConsumer = UploaderConsumer;